export enum FormFieldsTypes {
    Email = 'email',
    Password = 'password',
    // FirstName = 'firstName',
    // LastName = 'lastName'
}

export enum SignUpInputTypes {
    Input= 'input',
    Password= 'password'
}

export interface ISignUpFields {
    [FormFieldsTypes.Email]: string;
    [FormFieldsTypes.Password]: string;
    // [FormFieldsTypes.FirstName]: string;
    // [FormFieldsTypes.LastName]: string;
}

export const SIGNUP_FORM_INITIAL_STATE: ISignUpFields = {
    [FormFieldsTypes.Email]: '',
    [FormFieldsTypes.Password]: '',
    // [FormFieldsTypes.FirstName]: '',
    // [FormFieldsTypes.LastName]: '',
};

export interface ISignUpRequestData {
    [FormFieldsTypes.Email]: string;
    [FormFieldsTypes.Password]: string;
    // [FormFieldsTypes.FirstName]: string;
    // [FormFieldsTypes.LastName]: string;
}
